import {NavLink} from 'react-router';
import {SVG} from '../../../constants/assetLists';
import useText from '../../../hooks/useText';

type Props = {
  handleMenuOpenClose?: (state: boolean) => void;
};

function SettingsLink({handleMenuOpenClose}: Props) {
  const t = useText();

  return (
    <NavLink
      to={'/settings'}
      onClick={() => handleMenuOpenClose?.(false)}
      className={`flex items-center gap-4 rounded-[16px] text-decoration-none transition-opacity duration-200 hover:opacity-50`}>
      <div className="w-[24px] h-[24px]">
        <img
          src={SVG.settingsIcon}
          alt="icon"
          className="w-full h-full object-contain"
        />
      </div>
      <span className={`lg:hidden text-sm font-medium text-gray50`}>
        {t('common.settings')}
      </span>
    </NavLink>
  );
}

export default SettingsLink;
